import { useEffect } from 'react';
import { trackServiceView, trackAppointmentRequest } from '@/utils/metaPixel';
import { hasMarketingConsent } from "@/utils/consent";
import { initializeMetaPixel } from "@/utils/metaPixel";

export const useServiceTracking = (serviceName: string) => {
  useEffect(() => {
    // Track service page view
    if (!hasMarketingConsent()) return;
    initializeMetaPixel();
    trackServiceView(serviceName);
  }, [serviceName]);

  const handleAppointmentClick = () => {
    if (!hasMarketingConsent()) return;
    initializeMetaPixel();
    trackAppointmentRequest(serviceName);
  };

  return {
    handleAppointmentClick
  };
}; 